<div class="w-75 mx-auto">

  <h4>AGB</h4>

  <p>1. Allgemeines</p>
  <p> Für sämtliche von iLogistiX GmbH (im Folgenden: Personaldienstleister) aus und im Zusammenhang mit
    Arbeitnehmerüberlassungsverträgen erbrachte oder zu erbringende Dienstleistungen gelten die nachstehen-den
    Allgemeinen Geschäftsbedingungen (AGB). Abweichende AGB des Kunden (im Folgenden: Auftragge-ber) gelten auch dann
    nicht, wenn der Personaldienstleister nicht ausdrücklich widerspricht oder der Auftrag-geber erklärt, nur zu seinen
    Bedingungen abschließen zu wollen.</p>

  <p>2. Vertragsabschluss</p>
  <ul class="list-agb">
    <li>2.1. Das Vertragsverhältnis kommt durch das Angebot des Personaldienstleisters nach Maßgabe des
      Ar-beitnehmerüberlassungsvertrages sowie dieser Allgemeinen Geschäftsbedingungen und die schriftliche
      Annahmeerklärung des Auftraggebers mit Unterzeichnung des Arbeitnehmerüberlassungsvertrages
      zustande. Dem Auftraggeber ist bekannt, dass für den Personaldienstleister keine Leistungspflichten
      bestehen, sofern die unterzeichnete Vertragsurkunde durch den Auftraggeber nicht zurückgereicht wird (§ 12 Abs. 1
      Arbeitnehmerüberlassungsgesetz (im Folgenden: AÜG)).
    </li>

    <li> 2.2. Sofern der Auftraggeber beabsichtigt, dem Zeitarbeitnehmer den Umgang mit Geld und/oder Wertsa-chen zu
      übertragen, wird er vorab mit dem Personaldienstleister eine gesonderte Vereinbarung treffen.
    </li>

    <li> 2.3. Der Personaldienstleister ist Mitglied des Gesamtverbandes der Personaldienstleister e.V (GVP). Der
      Personaldienstleister erklärt, dass in die Arbeitsverträge, die er mit den beim Auftraggeber eingesetzten
      Arbeitnehmern abgeschlossen hat, das iGZ-DGB-Tarifwerk (einschließlich der Branchenzuschlagstarif-verträge) und
      ergänzende, ändernde oder ersetzende Tarifverträge, die der GVP als Rechtsnachfolger des Interessenverbandes
      Deutscher Zeitarbeitsunternehmen e.V. (iGZ) abgeschlossen hat, vollständig in seiner jeweils gültigen Fassung
      einbezogen werden.
    </li>

    <li> 2.4. Der Auftraggeber sichert zu, dass kein im Rahmen der Einzelarbeitnehmerüberlassungsverträge einge-setzter
      Arbeitnehmer in den letzten sechs Monaten vor dem im Einzelarbeitnehmerüberlassungsvertrag bezeichneten
      Einsatzbeginn aus einem Arbeitsverhältnis mit dem Auftraggeber selbst oder einem mit dem Auftraggeber konzernmäßig
      im Sinne des § 18 Aktiengesetz verbundenen Unternehmen ausge-schieden ist.
    </li>

    <li> 2.5. Der Auftraggeber sichert zu, dass kein im Rahmen der Arbeitnehmerüberlassungsverträge eingesetzter
      Arbeitnehmer in den letzten drei Monaten und einem Tag über einen anderen Personaldienstleister beim Auftraggeber
      tätig war. Andernfalls informiert der Auftraggeber den Personaldienstleister über die kür-zere Unterbrechung.
      Vorangegangene Einsätze werden in diesem Falle bei der Vereinbarung der Ein-satzdauer berücksichtigt.
    </li>

    <li> 2.6. Sofern der Personaldienstleister dem Auftraggeber Arbeiter im Sinne des § 1b Satz 1 AÜG (Verbot der
      Überlassung in das Bauhauptgewerbe) überlässt, bestätigt der Auftraggeber, dass im Einsatzbetrieb nicht
      überwiegend
      Gewerke im Sinne des § 1 der Baubetriebe-Verordnung erbracht werden. Der Auf-traggeber ist verpflichtet, den
      Personaldienstleister über eine Änderung unverzüglich zu informieren.
    </li>
  </ul>

  <p> 3. Arbeitsrechtliche Beziehungen / Kettenverleih</p>
  <ul class="list-agb">
    <li> 3.1. Der Abschluss dieser Vereinbarung begründet keine arbeitsrechtliche Beziehung zwischen dem
      Zeitar-beitnehmer
      und dem Auftraggeber. Der Personaldienstleister ist Arbeitgeber des Zeitarbeitnehmers. Der Personaldienstleister
      sichert dem Auftraggeber zu, dass nur Arbeitnehmer überlassen werden, die in
      einem Arbeitsverhältnis zum Personaldienstleister stehen.
    </li>

    <li> 3.2. Der Auftraggeber sichert zu, dass er Zeitarbeitnehmer weder offen (offengelegte Arbeitnehmerüberlas-sung)
      noch verdeckt (verdeckte Arbeitnehmerüberlassung, z.B. Scheinwerkverträge) weiter überlässt (kein
      Kettenverleih).
    </li>

    <li> 3.3. Für die Dauer des Einsatzes bei dem Auftraggeber obliegt diesem die Ausübung des arbeitsbezogenen
      Weisungsrechts. Der Auftraggeber wird dem Zeitarbeitnehmer nur solche Tätigkeiten zuweisen, die dem mit dem
      Personaldienstleister vertraglich vereinbarten Tätigkeitsbereich unterliegen und die dem Aus-bildungsstand des
      jeweiligen Zeitarbeitnehmers entsprechen. Im Übrigen verbleibt das Direktionsrecht bei dem
      Personaldienstleister.
    </li>
  </ul>

  <p> 4. Fürsorge- und Mitwirkungspflichten des Auftraggebers / Arbeitsschutz</p>
  <ul class="list-agb">
    <li> 4.1. Der Auftraggeber übernimmt die Fürsorgepflicht im Zusammenhang mit Arbeitsschutzmaßnahmen am
      Beschäftigungsort des Zeitarbeitnehmers (§ 618 BGB, § 11 Absatz 6 AÜG). Er stellt den Personal-dienstleister
      insoweit von sämtlichen Ansprüchen des Zeitarbeitnehmers sowie sonstiger Dritter frei, die aus einer nicht oder
      nicht ausreichenden Wahrnehmung dieser Pflicht resultieren.
    </li>

    <li> 4.2. Sofern für den Einsatz der überlassenen Arbeitnehmer</li>
    <ul class="list-agb">
      <li> 4.2.1. behördliche Genehmigungen erforderlich sind oder werden, verpflichtet sich der Auftraggeber, diese vor
        Aufnahme der Beschäftigung durch den Zeitarbeitnehmer einzuholen und dem Per-sonaldienstleister die Genehmigung
        auf
        Anfrage vorzulegen;
      </li>
      <li> 4.2.2. arbeitsmedizinische Vorsorgeuntersuchungen erforderlich sind, werden diese vom Personal-dienstleister
        vor
        Überlassungsbeginn durchgeführt und dem Auftraggeber nachgewiesen;
      </li>
      <li> 4.2.3. Nachuntersuchungen erforderlich werden, teilt der Auftraggeber dies dem Personaldienstleister
        schriftlich
        mit. Nachuntersuchungen werden von dem für den Auftraggeber zuständigen Werksarzt oder, falls ein solcher nicht
        vorhanden ist, von einem vom Personaldienstleister be-auftragten Betriebsarzt auf Kosten des
        Personaldienstleisters
        durchgeführt. Eine abweichende Kostenaufteilung kann vereinbart werden.
      </li>
    </ul>
    <li> 4.3. Der Auftraggeber ist verpflichtet, die gesetzlichen Arbeitsschutz- und Unfallverhütungsvorschriften
      ein-zuhalten. Insbesondere ist der Auftraggeber verpflichtet,
    </li>

    <ul class="list-agb">
      <li> 4.3.1. gemäß § 5 ArbSchG vor Aufnahme der Tätigkeit des Zeitarbeitnehmers die mit dessen Tätig-keit
        verbundenen
        Gefährdungen zu ermitteln und die geeigneten Schutzmaßnahmen nach dem Stand der Technik vor Aufnahme der
        Tätigkeit
        des Zeitarbeitnehmers zu treffen;
      </li>
      <li> 4.3.2. den Zeitarbeitnehmer vor Tätigkeitsbeginn gemäß § 12 ArbSchG über Sicherheit und Gesund-heitsschutz am
        entsprechenden Arbeitsplatz ausreichend und angemessen zu unterweisen;
      </li>
      <li> 4.3.3. die Regelungen des Arbeitszeitgesetzes für den jeweiligen Einsatz im Betrieb des Auftragge-bers
        umzusetzen.
        Die Beschäftigung des Zeitarbeitnehmers über 10 Stunden pro Werktag hin-aus, bedarf der Absprache mit dem
        Personaldienstleister. Über werktägliche 10 Stunden hin-aus darf nur gearbeitet werden, wenn ein Tarifvertrag
        oder
        eine Betriebsvereinbarung aufgrund eines Tarifvertrags des Auftraggebers gemäß § 7 Arbeitszeitgesetz oder eine
        behördliche Ge-nehmigung dies zulässigerweise vorsieht oder ein außergewöhnlicher Fall im Sinne des § 14
        Arbeitszeitgesetz gegeben ist;
      </li>
      <li> 4.3.4. im Falle von Sonn- oder Feiertagsarbeit dem Personaldienstleister einen Nachweis darüber zur Verfügung
        zu
        stellen, aus dem sich ergibt, dass eine Berechtigung zur Anordnung von Sonn- bzw. Feiertagsarbeit besteht;
      </li>
      <li> 4.3.5. dem Personaldienstleister einen Arbeitsunfall sofort zu melden und ihm alle nach § 193 Absatz 1 SGB
        VII
        erforderlichen Informationen zur Verfügung zu stellen. Der Personaldienstleister meldet den Arbeitsunfall bei
        dem
        zuständigen Unfallversicherungsträger.
      </li>
    </ul>

    <li> 4.4. Der Auftraggeber stellt dem Personaldienstleister unverzüglich nach Überlassung des Zeitarbeitnehmers eine
      den Anforderungen des § 6 ArbSchG genügende Dokumentation zur Verfügung.
    </li>

    <li> 4.5. Zur Wahrnehmung seiner Arbeitgeberpflichten wird dem Personaldienstleister während der Arbeitszeiten in
      Absprache mit dem Auftraggeber ein Zutrittsrecht zu den Arbeitsplätzen der Arbeitnehmer einge-räumt.
    </li>

    <li> 4.6. Der Personaldienstleister hat seine Arbeitnehmer über geltende Unfallverhütungsvorschriften,
      Sicher-heitsregeln und -hinweise zu informieren und zu belehren. Der Auftraggeber hat vor Arbeitsaufnahme der
      eingesetzten Arbeitnehmer eine arbeitsplatzspezifische Arbeitsschutz- und Sicherheitsbelehrung durchzuführen. Die
      Belehrung ist vom Auftraggeber zu dokumentieren und dem Personaldienstleister in Kopie auszuhändigen.
    </li>

    <li> 4.7. Sofern Zeitarbeitnehmer des Personaldienstleisters aufgrund fehlender oder mangelhafter
      Sicherheits-einrichtungen oder Vorkehrungen im Betrieb des Auftraggebers die Arbeitsleistung ablehnen, haftet der
      Auftraggeber für die dadurch entstehenden Ausfallzeiten.
    </li>
  </ul>

  <p> 5. Zurückweisung / Austausch von Zeitarbeitnehmern</p>
  <ul class="list-agb">
    <li> 5.1. Der Auftraggeber ist berechtigt, einen Zeitarbeitnehmer durch schriftliche Erklärung gegenüber dem
      Personaldienstleister zurückzuweisen, wenn ein Grund vorliegt, der den Personaldienstleister zu einer
      außerordentlichen Kündigung des Arbeitsverhältnisses mit dem Zeitarbeitnehmer berechtigen würde
      (§ 626 BGB). Der Auftraggeber ist verpflichtet, die Gründe für die Zurückweisung detailliert darzulegen. Im Falle
      der Zurückweisung ist der Personaldienstleister berechtigt, andere fachlich gleichwertige Zeit-arbeitnehmer an den
      Auftraggeber zu überlassen.
    </li>

    <li> 5.2. Stellt der Auftraggeber innerhalb der ersten vier Stunden fest, dass ein Zeitarbeitnehmer des
      Personal-dienstleisters nicht für die vorgesehene Tätigkeit geeignet ist und besteht er auf Austausch, werden ihm,
      nach vorheriger Rücksprache, bis zu vier Arbeitsstunden nicht berechnet.
    </li>

    <li>5.3. Darüber hinaus ist der Personaldienstleister jederzeit berechtigt, aus organisatorischen oder gesetzli-chen
      Gründen an den Auftraggeber überlassene Zeitarbeitnehmer auszutauschen und fachlich gleich-wertige
      Zeitarbeitnehmer
      zu überlassen.
    </li>
  </ul>


  <p> 6. Mitteilungspflichten / Anpassung des Verrechnungssatzes</p>
  <ul class="list-agb">
    <li> 6.1. Der Einsatz in einem anderen als dem im Arbeitnehmerüberlassungsvertrag genannten Betrieb des
      Auf-traggebers,
      der Austausch von Arbeitnehmern innerhalb des Betriebes sowie die Zuweisung anderer als der in diesem Vertrag
      vereinbarten Tätigkeiten bedürfen der Zustimmung des Personaldienstleisters. Der Auftraggeber ist verpflichtet,
      den
      Personaldienstleister rechtzeitig vorab darüber zu informieren, wenn der Zeitarbeitnehmer im Ausland eingesetzt
      werden soll. Änderungen des Einsatzortes sowie des Arbeitsbereiches berechtigen den Personaldienstleister zur
      Änderung des Stundenverrechnungssatzes.
    </li>

    <li> 6.2. Der Auftraggeber teilt dem Personaldienstleister auch vor dem Hintergrund von Mindestlohnverpflich-tungen
      aufgrund des Arbeitnehmer-Entsendegesetzes eine Änderung der Tätigkeit der überlassenen Ar-beitnehmer umgehend
      mit.
      Die Parteien sind sich einig, dass der Personaldienstleister berechtigt ist, den vereinbarten Stundensatz
      anzupassen, wenn die ausgeübte Tätigkeit mindestlohnpflichtig wird oder wenn der Mindestlohn steigt.
    </li>

    <li> 6.3. Der Auftraggeber verpflichtet sich, dem Personaldienstleister unaufgefordert unverzüglich etwaige für ihn
      in
      Zukunft geltenden Tarifverträge, die eine Abweichung von der zukünftigen Überlassungshöchst-dauer von 18 Monaten
      vorsehen, und/oder etwaige im Betrieb des Auftraggebers, an den der Personal-dienstleister Arbeitnehmer überlässt,
      zukünftig geltenden Betriebsvereinbarungen, die aufgrund eines Tarifvertrages eine Abweichung von der zukünftigen
      Überlassungshöchstdauer von 18 Monaten vorse-hen, in Kopie zu übermitteln. Dies gilt insbesondere, wenn aufgrund
      eines Tarifvertrages und/oder einer Betriebsvereinbarung eine kürzere Überlassungshöchstdauer als 18 Monate
      geregelt
      ist.
    </li>

    <li> 6.4. Der Auftraggeber teilt dem Personaldienstleister mit, wenn und soweit er den Zeitarbeitnehmern Zugang zu
      seinen Gemeinschaftseinrichtungen gewährt. Über diesbezügliche Änderungen unterrichtet der Auf-traggeber den
      Personaldienstleister unverzüglich.
    </li>
  </ul>

  <p> 7. Personalauswahl / Personaleinsatz / Streik</p>
  <ul class="list-agb">
    <li>7.1. Die Personalauswahl erfolgt durch den Personaldienstleister auf Grundlage der in der textlichen
      Be-darfsmeldung vereinbarten Anforderungsprofile.
    </li>

    <li> 7.2. Der Personaldienstleister verpflichtet sich, für die vorgesehenen Arbeiten geeignetes Personal
      auszu-wählen.
      Bei angeforderten Qualifikationen, für die ein anerkannter Ausbildungsberuf existiert, verpflich-tet sich der
      Personaldienstleister, nur solches Personal auszuwählen und dem Auftraggeber zu überlas-sen, das diese
      Berufsausbildung erfolgreich abgeschlossen hat. Abweichendes muss schriftlich ver-einbart werden.
    </li>

    <li> 7.3. Der Personaldienstleister stellt sicher, dass die eingesetzten Arbeitnehmer, sofern sie nicht
      Staatsan-gehörige eines EWR-Staates oder der Schweiz sind, zur Aufnahme der Tätigkeit aufgrund
      ausländer-rechtlicher
      Regelungen berechtigt sind. Auf Nachfrage des Auftraggebers sind vom Personaldienstleis-ter entsprechende
      Nachweise
      vorzulegen.
    </li>

    <li> 7.4. Der Personaldienstleister ist berechtigt, bei dem Auftraggeber eingesetzte Arbeitnehmer jederzeit gegen
      andere Arbeitnehmer auszutauschen, sofern diese den vereinbarten Anforderungsprofilen entsprechen. Der
      Auftraggeber
      ist hierüber unverzüglich zu informieren.
    </li>

    <li> 7.5. Der Auftraggeber hat einen Anspruch auf Austausch des Zeitarbeitnehmers, wenn dieser für die vorge-sehene
      Tätigkeit nicht geeignet ist. Die fehlende Eignung muss entsprechend nachgewiesen werden. Dieser Anspruch steht
      dem
      Auftraggeber auch dann zu, wenn Gründe vorliegen, die ihn im Falle eigener Arbeitgeberposition zur
      außerordentlichen
      Kündigung berechtigen würde (§ 626 BGB). Ist der Auftrag-geber der Auffassung, es liege ein Anspruch auf Austausch
      im Sinne dieses Absatzes vor und will er deswegen den Einsatz des betreffenden Arbeitnehmers beenden, so hat er
      den
      Personaldienstleister hierüber unverzüglich in Kenntnis zu setzen und den Austausch zu begründen.
    </li>

    <li> 7.6. Nimmt der überlassene Arbeitnehmer seine Tätigkeit beim Auftraggeber nicht oder nicht zeitgerecht auf,
      unterrichtet der Auftraggeber den Personaldienstleister hierüber unverzüglich. Unterbleibt die unverzüg-liche
      Anzeige durch den Auftraggeber, stehen diesem Ansprüche aus und im Zusammenhang mit der nicht oder nicht
      rechtzeitig
      erfolgten Aufnahme der Tätigkeit durch den Zeitarbeitnehmer gegen den Personaldienstleister nicht zu.
    </li>

    <li> 7.7. Wird der Betrieb des Auftraggebers bestreikt, darf dieser entgegen der Regelung in § 11 Absatz 5 AÜG keine
      Zeitarbeitnehmer in dem Betrieb tätig werden lassen. Darüber hinaus gilt das Einsatzverbot für Streiks, die von
      Mitgliedsgewerkschaften der DGB-Tarifgemeinschaft initiiert wurden, auch für bereits vor Beginn der
      Arbeitskampfmaßnahme eingesetzte Arbeitnehmer. Demnach wird der Zeitarbeitnehmer im Umfang des Streikaufrufs nicht
      in Betrieben oder Betriebsteilen eingesetzt, die ordnungsgemäß be-streikt werden. Der Auftraggeber stellt sicher,
      dass keine Zeitarbeitnehmer eingesetzt werden, soweit das Einsatzverbot reicht. Der Personaldienstleister ist
      insoweit nicht verpflichtet, Arbeitnehmer zu über-lassen. Von den vorstehenden Regelungen können die Parteien des
      Arbeitskampfes im Einzelfall ab-weichen und den Einsatz von Zeitarbeitnehmern vereinbaren (z.B. in
      Notdienstvereinbarungen). Es gilt insoweit § 11 Absatz 5 Satz 2 AÜG. Der Auftraggeber informiert den
      Personaldienstleister unverzüglich über einen laufenden oder geplanten Streik.
    </li>
  </ul>

  <p> 8. Abrechnung / Preisanpassung</p>
  <ul class="list-agb">
    <li> 8.1. Bei sämtlichen von dem Personaldienstleister angegebenen Verrechnungssätzen handelt es sich um
      Nettoangaben.
      Der Personaldienstleisterwird dem Auftraggeber bei Beendigung des Auftrages - bei fortdauernder Überlassung
      wöchentlich - eine Rechnung unter Ausweis der gesetzlichen Mehrwertsteuer stellen, es sei denn die Parteien
      vereinbaren ausdrücklich eine abweichende Abrechnungsweise.
    </li>

    <li> 8.2. Die Abrechnung erfolgt auf Basis der effektiv geleisteten Arbeitsstunden, wobei mindestens die
      ver-einbarte
      betriebliche Arbeitszeit abzurechnen ist. Es sind die Arbeitsstunden für jeden überlassenen Ar-beitnehmer durch
      Tätigkeitsnachweise zu belegen, die je überlassenem Arbeitnehmer wöchentlich aus-zufüllen und von einem
      Beauftragten
      des Auftraggebers nach sachlicher Prüfung zu unterschreiben sind. Die überlassenen Arbeitnehmer haben hierzu die
      beim Auftraggeber vorgegebenen Instrumente (Arbeitszeitnachweis/elektronische Arbeitszeiterfassung) zu nutzen,
      soweit diese vorhanden sind.
    </li>

    <li>8.3. Der Auftraggeber ist verpflichtet, eine zeitnahe Ausstellung der Tätigkeitsweise zu ermöglichen. Aus den
      Tätigkeitsnachweisen müssen der Beginn und das Ende der täglichen Arbeitszeit mit Pausen er-sichtlich sein.
      Überstunden sind gesondert auszuweisen.
    </li>

    <li> 8.4. Die Rechnungsbeträge sind mit Zugang der von dem Personaldienstleister erteilten Abrechnung bei dem
      Auftraggeber sofort – ohne Abzug - fällig. Der Auftraggeber gerät in Verzug, wenn der Rech-nungsbetrag nicht
      innerhalb von 10 Kalendertagen ab Zugang der Rechnung auf dem Geschäftskonto des Personaldienstleisters eingeht.
      Einer vorherigen Mahnung bedarf es nicht (§ 286 Absatz 2 BGB). § 288 BGB (Verzugszinsen) findet Anwendung.
    </li>

    <li> 8.5. Die von dem Personaldienstleister überlassenen Zeitarbeitnehmer sind nicht zur Entgegennahme von
      Vorschüssen
      oder Zahlungen auf die von dem Personaldienstleister erteilten Abrechnungen befugt. Zahlungen an den
      Zeitarbeitnehmer haben keine Erfüllungswirkung.
    </li>

    <li> 8.6. Befindet sich der Auftraggeber (teilweise) mit der Vergütungszahlung in Verzug, so wird die Vergütung für
      sämtliche noch nicht fakturierten Stunden, deren Ableistung der Auftraggeber auf einem Tätigkeits-nachweis bereits
      durch seine Unterschrift bestätigt hat, sofort fällig. Dem Personaldienstleister steht bei Nichtleistung durch den
      Auftraggeber ein Leistungsverweigerungsrecht zu.
    </li>

    <li> 8.7. Im Falle des Zahlungsverzuges des Auftraggebers ist der Personaldienstleister berechtigt, gemäß
      § 288 Abs. 2 BGB einen Verzugszins in Höhe von 9 Prozentpunkten über dem Basiszinssatz zu verlan-gen. Dem
      Auftraggeber bleibt in diesem Fall der Nachweis vorbehalten, dass ein Schaden beim Perso-naldienstleister nicht
      oder
      nicht in diesem Umfang entstanden ist.
    </li>

    <li> 8.8. Der Personaldienstleister ist berechtigt, die im Arbeitnehmerüberlassungsvertrag vereinbarte
      Überlas-sungsvergütung nach billigem Ermessen anzupassen, wenn sich Veränderungen in der Kostensituation ergeben.
      Das billige Ermessen setzt voraus, dass bei der Anpassung lediglich die neue Kostensituation berücksichtigt wird,
      wie sie z.B. durch eine Erhöhung der Entgelte im iGZ-DGB-Tarifwerk oder in den ergänzenden, ändernden oder
      ersetzenden Tarifverträgen, die der GVP als Rechtsnachfolger des iGZ abgeschlossen hat (siehe Ziffer 2.3), durch
      die
      Geltung eines neu in Kraft getretenen oder bisher nicht einschlägigen Branchenzuschlagstarifvertrags oder durch
      Änderungen beim Equal Pay eintritt. Vorste-hendes gilt auch, wenn die ausgeübte Tätigkeit mindestlohnpflichtig
      wird
      oder wenn der Mindestlohn steigt.
    </li>
  </ul>


  <p> 9. Ausschluss von Aufrechnung / Zurückbehaltungsrecht</p>

  <p> Der Auftraggeber ist nicht berechtigt, gegenüber Forderungen des Personaldienstleisters aufzurechnen oder ein
    Zurückbehaltungsrecht geltend zu machen, es sei denn, die vom Auftraggeber geltend ge-machte Gegenforderung ist
    unbestritten oder rechtskräftig festgestellt.</p>

  <p> 10. Gewährleistung / Haftung</p>
  <ul class="list-agb">
    <li> 10.1. Der Personaldienstleister stellt sicher, dass die eingesetzten Arbeitnehmer über die erforderliche
      Quali-fikation verfügen. Auf Nachfrage des Auftraggebers weist er die Qualifikation nach.
    </li>

    <li>10.2. Im Hinblick darauf, dass die überlassenen Arbeitnehmer unter Leitung und Aufsicht des Auftraggebers ihre
      Tätigkeit ausüben, haftet der Personaldienstleister nicht für Schäden, die diese in Ausübung oder anlässlich ihrer
      Tätigkeit verursachen. Der Auftraggeber stellt den Personaldienstleister von allen etwa-igen Ansprüchen frei, die
      Dritte im Zusammenhang mit der Ausführung und Verrichtung der den Zeitar-beitnehmern übertragenen Tätigkeiten
      erheben sollten.
    </li>

    <li> 10.3. Im Übrigen ist die Haftung des Personaldienstleisters sowie seiner gesetzlichen Vertreter und
      Erfül-lungsgehilfen auf Vorsatz und grobe Fahrlässigkeit beschränkt. Diese Haftungsbeschränkung gilt nicht für
      Schäden, die auf einer Verletzung des Lebens, des Körpers oder der Gesundheit beruhen. Das be-trifft sowohl
      gesetzliche als auch vertragliche Haftungstatbestände, insbesondere Fälle im Falle des Verzuges, der
      Unmöglichkeit,
      des Unvermögens, der Pflichtverletzung oder der unerlaubten Handlung.
      Namentlich haftet der Personaldienstleister nicht für Arbeitsergebnisse der Zeitarbeitnehmer oder Schäden, die
      diese
      in Ausübung oder anlässlich ihrer Tätigkeit verursachen oder die dem Auftraggeber durch Unpünktlichkeit oder
      Abwesenheit der Zeitarbeitnehmer entstehen.
    </li>

    <li>10.4. Der Auftraggeber stellt den Personaldienstleister von allen Forderungen frei, die dem
      Personaldienst-leister
      aus einer Verletzung des Auftraggebers der sich aus diesem Vertrag ergebenden Zusicherungen und Verpflichtungen
      (z.B. Prüf- und Mitteilungspflichten) erwachsen. Der Personaldienstleister ver-pflichtet sich, sich gegenüber
      etwaigen Anspruchstellern auf einschlägige Ausschlussfristen zu beru-fen.
    </li>
  </ul>

  <p>11. Übernahme von Zeitarbeitnehmern / Vermittlungsprovision</p>
  <ul class="list-agb">
    <li> 11.1. Eine Vermittlung liegt vor, wenn der Auftraggeber oder ein mit ihm rechtlich oder wirtschaftlich
      verbun-denes Unternehmen während der Dauer des Arbeitnehmerüberlassungsvertrages mit dem Arbeitnehmer des
      Personaldienstleisters ein Arbeitsverhältnis eingeht. Eine Vermittlung liegt auch dann vor, wenn der Auftraggeber
      oder ein mit ihm rechtlich oder wirtschaftlich verbundenes Unternehmen innerhalb von 6 Monaten nach Beendigung der
      Überlassung, höchstens aber 12 Monate nach Beginn der Überlassung, mit dem Zeitarbeitnehmer ein Arbeitsverhältnis
      eingeht. Dem Auftraggeber bleibt in diesem Fall der Nachweis vorbehalten, dass der Abschluss des
      Arbeitsverhältnisses nicht aufgrund der vorangegan-genen Überlassung erfolgt ist.
    </li>

    <li> 11.2. Eine Vermittlung liegt ebenfalls vor, wenn der Auftraggeber oder ein mit ihm rechtlich oder
      wirtschaft-lich
      verbundenes Unternehmen direkt nach der Herstellung des Kontaktes zu dem Bewerber durch den Personaldienstleister
      ohne eine vorherige Überlassung ein Arbeitsverhältnis eingeht.
    </li>

    <li> 11.3. Maßgebend für den Zeitpunkt der Begründung des Arbeitsverhältnisses zwischen dem Auftraggeber und dem
      Zeitarbeitnehmer ist nicht der Zeitpunkt der Arbeitsaufnahme, sondern der Zeitpunkt des Ab-schlusses des
      Arbeitsvertrages.
    </li>

    <li>11.4. Der Auftraggeber ist verpflichtet, dem Personaldienstleister mitzuteilen, ob und wann ein Arbeitsver-trag
      abgeschlossen wurde. Wenn im Streitfall der Personaldienstleister Indizien für den Bestand eines
      Arbeitsverhältnisses zwischen dem Auftraggeber und dem Zeitarbeitnehmer darlegt, trägt der Auftrag-geber die
      Beweislast dafür, dass ein Arbeitsverhältnis nicht eingegangen wurde.
    </li>

    <li> 11.5. In den Fällen der Ziff. 11.1. und 11.2. hat der Auftraggeber eine Vermittlungsprovision an den
      Perso-naldienstleister zu zahlen. Befristete Arbeitsverhältnisse sind im gleichen Umfang provisionspflichtig wie
      unbefristete Arbeitsverhältnisse. Die Höhe der Vermittlungsprovision beträgt bei direkter Übernah-me des
      Zeitarbeitnehmers ohne vorherige Überlassung 2,5 Bruttomonatsgehälter. Im Übrigen beträgt die
      Vermittlungsprovision
      im Falle einer Übernahme innerhalb der ersten 3 Monate nach Beginn der Überlassung 2 Bruttomonatsgehälter, bei
      einer
      Übernahme innerhalb des 4. bis 6. Monats nach Beginn der Überlassung 1,5 Bruttomonatsgehälter, bei einer Übernahme
      innerhalb des 7. bis 9. Monats 1 Brut-tomonatsgehalt und bei einer Übernahme innerhalb des 10. bis 12. Monats nach
      Beginn der Überlas-sung 0,5 Bruttomonatsgehälter.
    </li>

    <li> 11.6. Berechnungsgrundlage der Vermittlungsprovision ist das zwischen dem Auftraggeber und dem
      Zeitar-beitnehmer
      vereinbarte Bruttomonatsgehalt, mindestens aber das zwischen dem Personaldienstleister und dem Zeitarbeitnehmer
      vereinbarte Bruttomonatsgehalt. Der Auftraggeber legt dem Personaldienst-leister eine Kopie des unterschriebenen
      Arbeitsvertrages vor. Bei Unterbrechungen in der Überlassung ist der Beginn der letzten Überlassung vor Begründung
      des Arbeitsverhältnisses maßgeblich. Die Ver-mittlungsprovision ist zzgl. der gesetzlichen Mehrwertsteuer zu
      zahlen.
      Die Provision ist zahlbar 14 Ta-ge nach Eingang der Rechnung.
    </li>

    <li> 11.7. Wird der Mitarbeiter aufgrund eines freien Mitarbeitervertrages bzw. eines Vertrages mit einem
      Selb-ständigen für den Auftraggeber tätig, gelten die Bestimmungen entsprechend mit der Maßgabe, dass anstatt des
      Bruttomonatsgehaltes das zwischen dem Auftraggeber und dem Mitarbeiter vereinbarte
      monatliche Honorar die Basis der Berechnungsgrundlage bildet.
    <li> 11.8. Die vorstehenden Bestimmungen gelten auch im Falle der Vermittlung des Arbeitnehmers in ein
      Aus-bildungsverhältnis mit dem Auftraggeber. Berechnungsgrundlage der Vermittlungsprovision ist in die-sem Falle
      die
      zwischen dem Auftraggeber und dem Zeitarbeitnehmer vereinbarte Bruttoausbildungs-vergütung, mindestens aber das
      zwischen dem Personaldienstleister und dem Zeitarbeitnehmer zuletzt vereinbarte Bruttomonatsgehalt.
    </li>
  </ul>

  <p> 12. Vertragslaufzeit / Kündigung</p>
  <ul class="list-agb">
    <li> 12.1. Soweit der Arbeitnehmerüberlassungsvertrag nicht befristet geschlossen wurde, läuft er auf unbe-stimmte
      Dauer. In der ersten Woche des Einsatzes des Zeitarbeitnehmers ist der Auftraggeber
      berechtigt, das Vertragsverhältnis mit einer Frist von einem Arbeitstag zu kündigen. Im Übrigen steht beiden
      Parteien das Recht zu, die Vereinbarung mit einer Frist von drei Arbeitstagen zum Ende einer Kalenderwoche zu
      kündigen, falls die Parteien keine andere Regelung treffen.
    </li>

    <li> 12.2. Davon unberührt bleibt das Recht zur außerordentlichen Kündigung. Beiden Vertragsparteien steht ein
      außerordentliches Kündigungsrecht mit Monatsfrist zum Monatsende zu, wenn das AÜG grundsätzlich geändert werden
      sollte. Der Personaldienstleister ist insbesondere zur fristlosen Kündigung dieser Vereinbarung berechtigt, wenn
    </li>
    <ul class="list-agb">
      <li>12.2.1. die Eröffnung des Insolvenzverfahrens über das Vermögen des Auftraggebers beantragt ist, ein
        Insolvenzverfahren eröffnet oder mangels Masse abgewiesen wurde oder ein sol-ches droht.
      </li>
      <li>12.2.2. der Auftraggeber eine fällige Rechnung auch nach erfolgter Mahnung und Fristsetzung nicht
        ausgleicht.
      </li>
      <li>12.2.3. der Auftraggeber gegen die Zusicherungen und Verpflichtungen im Sinne von Ziff. 10.4. verstößt.</li>
      <li>12.2.4. der Auftraggeber eine Preisanpassung nach Ziff. 8.8. nicht akzeptiert.</li>
    </ul>
    <li>12.3. Eine Kündigung dieser Vereinbarung durch den Auftraggeber ist nur wirksam, wenn sie gegenüber dem
      Personaldienstleister in Textform erklärt wird. Die durch den Personaldienstleister überlassenen Zeitar-beitnehmer
      sind zur Entgegennahme von Kündigungserklärungen nicht befugt.
    </li>
  </ul>

  <p> 13. Geheimhaltung / Datenschutz</p>
  <ul class="list-agb">
    <li> 13.1. Die Vertragsparteien verpflichten sich, alle ihnen während der Zusammenarbeit bekannt gewordenen
      Informationen einschließlich aller personenbezogenen Daten der überlassenen Zeitarbeitnehmer streng vertraulich zu
      behandeln. Das Gleiche gilt für alle erlangten Kenntnisse über internen Geschäftsvor-gänge und -abläufe der
      Vertragsparteien. Hiervon ausgenommen sind alle Daten und Informationen, die offenkundig oder allgemein bekannt
      sind.
    </li>

    <li> 13.2. Die Vertragsparteien verpflichten sich, die erlangten Informationen, Daten und Kenntnisse mit äußers-ter
      Sorgfalt zu behandeln. Sie treffen diejenigen Vorkehrungen, die zum Schutz der Informationen und
      Daten erforderlich sind, mindestens aber diejenigen Vorkehrungen, mit denen sie besonders sensible Informationen
      über ihr eigenes Unternehmen schützen. Sie verpflichten sich weiter, die erhaltenen
      Informationen und Daten ausschließlich zu Zwecken der vereinbarten Leistungserbringung zu verarbei-ten und sie
      weder
      anderweitig zu nutzen, noch sie an Dritte weiterzuleiten oder sie diesen zugänglich zu machen.
    </li>

    <li> 13.3. Die Vertragsparteien verpflichten sich zudem zur Einhaltung der Anforderungen der Datenschutzge-setze.
      Die
      jeweiligen Mitarbeiter werden auf das Datengeheimnis verpflichtet.
    </li>

    <li> 13.4. Die in dieser Ziff. festgelegten Verpflichtungen wirken auch nach Beendigung der Zusammenarbeit der
      Parteien
      fort. Der Auftraggeber verpflichtet sich, nach Beendigung die ihm bekannt gewordenen Informationen und Daten
      umgehend zu löschen, sofern gesetzliche Aufbewahrungspflichten nicht ent-gegenstehen. Vom Personaldienstleister
      erhaltene Datenträger sind zurückzugeben oder zu vernich-ten.
    </li>
  </ul>

  <p> 14. Schlussbestimmungen / Salvatorische Klausel</p>
  <ul class="list-agb">

    <li>14.1. Änderungen und Ergänzungen der Vereinbarung zwischen den Parteien bedürfen
      zu ihrer Wirksamkeit der
      Schriftform. Dies gilt auch für eine Änderung des Schriftformerfordernisses selbst. Anstelle der Schriftform darf
      auch die elektronische Form (§ 126a BGB) verwandt werden. Die von dem Personal-dienstleister überlassenen
      Zeitarbeitnehmer sind nicht berechtigt, Änderungen, Ergänzungen oder
      Nebenabreden des Arbeitnehmerüberlassungsvertrages mit dem Auftraggeber zu vereinbaren.
    </li>

    <li> 14.2. Gerichtsstand für alle Streitigkeiten aus und im Zusammenhang mit dem Vertragsverhältnis zwischen dem
      Personaldienstleister und dem Auftraggeber ist der Sitz der jeweiligen Geschäftsstelle des
      Per-sonaldienstleisters, die den vorliegenden Arbeitnehmerüberlassungsvertrag geschlossen hat, sofern der
      Auftraggeber Kaufmann ist. Der Personaldienstleister kann seine Ansprüche darüber hinaus auch bei den Gerichten
      des allgemeinen Gerichtsstandes des Auftraggebers geltend machen.
    </li>
    <li> 14.3. Für sämtliche Rechtsbeziehungen zwischen dem Personaldienstleister und dem Auftraggeber gilt
      aus-schließlich das Recht der Bundesrepublik Deutschland.
    </li>
    <li>14.4. Der Personaldienstleister erklärt, nicht an einem Verfahren zur alternativen Streitbeilegung in
      Verbrau-chersachen gemäß Gesetz über die alternative Streitbeilegung in Verbrauchersachen teilzunehmen.
    </li>
    <li>14.5. Sollte eine Bestimmung dieser Allgemeinen Geschäftsbedingungen oder der auf dieser Grundlage
      abgeschlossenen Arbeitnehmerüberlassungsverträge ganz oder teilweise unwirksam sein oder werden, so berührt dies
      nicht die Wirksamkeit der übrigen Bestimmungen. An Stelle der unwirksamen Bestim-mung tritt eine solche, die dem
      wirtschaftlichen Zweck am nächsten kommt.
    </li>
  </ul>

</div>
